import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { normalPresentor } from '../../../../utils/date';

const detailLabelMappings = {
  batch: 'batch',
  mfgDate: 'mfgDate',
  expDate: 'expDate',
  openingBalance: 'openingBalance',
  inward: 'inward',
  outward: 'outward',
  adjustment: 'adjustment',
  closingBalance: 'closingBalance',
  damages: 'damages',
  shortages: 'shortages',
  expiry: 'expiry',
};

const detailsLabelConfig = [
  {
    id: 1,
    label: detailLabelMappings.batch,
    sortable: true,
    className: 'sorting',
    title: 'Batch',
    show: true,
  },
  {
    id: 2,
    label: detailLabelMappings.mfgDate,
    title: 'MFG Date',
    sortable: true,
    className: 'sorting',
    show: true,
  },
  {
    id: 3,
    label: detailLabelMappings.expDate,
    title: 'Expiry Date',
    align: true,
    show: true,
  },
  {
    id: 4,
    label: detailLabelMappings.openingBalance,
    title: 'Opening Balance',
    align: true,
    show: true,
  },
  {
    id: 5,
    label: detailLabelMappings.inward,
    title: 'Inward',
    align: true,
    show: true,
  },
  {
    id: 6,
    label: detailLabelMappings.outward,
    title: 'Outward',
    align: true,
    show: true,
  },
  {
    id: 7,
    label: detailLabelMappings.adjustment,
    title: 'Adjustment',
    align: true,
    show: true,
  },
  {
    id: 8,
    label: detailLabelMappings.closingBalance,
    title: 'Closing Balance',
    align: true,
    show: true,
  },
  {
    id: 9,
    label: detailLabelMappings.damages,
    title: 'Damaged',
    align: true,
    show: true,
  },
  {
    id: 10,
    label: detailLabelMappings.shortages,
    title: 'Shortages',
    align: true,
    show: true,
  },
  {
    id: 11,
    label: detailLabelMappings.expiry,
    title: 'Expired',
    align: true,
    show: true,
  },
];

const returnDetailTableBody = (data) => {
  const table = {};
  table[detailLabelMappings.batch] = <td key={`${data.batch}-id`}>{data.SKUBatch.batchName}</td>;
  table[detailLabelMappings.mfgDate] = (
    <td key={`${data.batch}-mfgDate`}>{normalPresentor(data.SKUBatch.manufactureDate)}</td>
  );
  table[detailLabelMappings.expDate] = (
    <td key={`${data.SKUBatch.id}-expDate`} className='text-right'>
      {normalPresentor(data.SKUBatch.expiryDate)}
    </td>
  );
  table[detailLabelMappings.openingBalance] = (
    <td key={`${data.SKUBatch.id}-openingBalance`} className='text-right'>
      {data.opening}
    </td>
  );
  table[detailLabelMappings.inward] = (
    <td key={`${data.SKUBatch.id}-inward`} className='text-right'>
      {data.inward}
    </td>
  );

  table[detailLabelMappings.outward] = (
    <td key={`${data.SKUBatch.id}-outward`} className='text-right'>
      {data.outward}
    </td>
  );
  table[detailLabelMappings.adjustment] = (
    <td key={`${data.SKUBatch.id}-adjustment`} className='text-right'>
      <span className={!data.negative ? (data.adjustment !== 0 ? 'positive' : '') : 'negative'}>{data.adjustment}</span>
    </td>
  );
  table[detailLabelMappings.closingBalance] = (
    <td key={`${data.SKUBatch.id}-closingBalance`} className='text-right'>
      {data.closing}
    </td>
  );
  table[detailLabelMappings.damages] = (
    <td key={`${data.SKUBatch.id}-damages`} className='text-right'>
      {data.damages === null ? 0 : data.damages}
    </td>
  );
  table[detailLabelMappings.shortages] = (
    <td key={`${data.SKUBatch.id}-shortages`} className='text-right'>
      {data.SKUBatch.shortages === null ? 0 : data.SKUBatch.shortages}
    </td>
  );
  table[detailLabelMappings.expiry] = (
    <td key={`${data.SKUBatch.id}-expiry`} className='text-right'>
      {data.expiry === null ? 0 : data.expiry}
    </td>
  );
  table[detailLabelMappings.closingBalance] = <td key={`${data.SKUBatch.id}-closingBalance`} className="text-right">{data.closing}</td>;
  table[detailLabelMappings.damages] = <td key={`${data.SKUBatch.id}-damages`} className="text-right">{data.damages === null ? 0 : data.damages}</td>;
  table[detailLabelMappings.shortages] = <td key={`${data.SKUBatch.id}-shortages`} className="text-right">{data.shortages === null ? 0 : data.shortages}</td>;
  table[detailLabelMappings.expiry] = <td key={`${data.SKUBatch.id}-expiry`} className="text-right">{data.expiry === null ? 0 : data.expiry}</td>;
  return table;
};

const DetailTableBody = ({ data }) => {
  const tableBody = returnDetailTableBody(data);

  return <Fragment>{detailsLabelConfig.map((label) => (label.show ? tableBody[label.label] : null))}</Fragment>;
};

DetailTableBody.propTypes = {
  data: PropTypes.instanceOf(Object),
};

DetailTableBody.defaultProps = {
  data: {},
};

export { DetailTableBody, detailsLabelConfig };
